import "./Certificate.css";
const Certificate = () => {
  return (
    <div className="pricing-page">
      <img
        src="/images/certificate.jpg"
        alt="Certificate"
        className="certificate-image"
      />
    </div>
  );
};

export default Certificate;
